export const READ_STATUS_MODEL_LIST = `READ_STATUS_MODEL_LIST`
export const READ_STATUS_MODEL_LIST_SUCCEEDED = `READ_STATUS_MODEL_LIST_SUCCEEDED`
export const READ_STATUS_MODEL_LIST_FAILED = `READ_STATUS_MODEL_LIST_FAILED`

export const CREATE_STATUS_MODEL_LIST = `CREATE_STATUS_MODEL_LIST`
export const CREATE_STATUS_MODEL_LIST_SUCCEEDED = `CREATE_STATUS_MODEL_LIST_SUCCEEDED`
export const CREATE_STATUS_MODEL_LIST_FAILED = `CREATE_STATUS_MODEL_LIST_FAILED`

export const UPDATE_STATUS_MODEL_LIST = `UPDATE_STATUS_MODEL_LIST`
export const UPDATE_STATUS_MODEL_LIST_SUCCEEDED = `UPDATE_STATUS_MODEL_LIST_SUCCEEDED`
export const UPDATE_STATUS_MODEL_LIST_FAILED = `UPDATE_STATUS_MODEL_LIST_FAILED`
